import { render, staticRenderFns } from "./addLocation.vue?vue&type=template&id=1fdea24e"
import script from "./addLocation.vue?vue&type=script&lang=js"
export * from "./addLocation.vue?vue&type=script&lang=js"
import style0 from "./addLocation.vue?vue&type=style&index=0&id=1fdea24e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports